<template>
	<v-dialog
		v-model="open"
		max-width="900"
		@click:outside="open = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" v-if="answerTemplate.name">{{
					answerTemplate.name
				}}</v-toolbar-title>
				<v-toolbar-title style="color: white" v-else
					>{{ requirement.requirement_type.name }} | {{ requirement.subtitle }}</v-toolbar-title
				>
				<v-spacer></v-spacer>
				<v-btn
					v-if="userEditableFlag && (answer.status_id == 'draft' || answer.status_id == 'refused')"
					icon
					dark
					@click="$router.push({ name: 'answer', params: { id: answer.id } })"
				>
					<v-icon>mdi-edit</v-icon>
				</v-btn>
				<v-btn icon dark @click="open = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<v-sheet elevation="0" class="mt-4">
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">状態</th>
								<td width="70%" class="no-wrap">
									{{ toJapanese(answer.status_id) }}
									<v-icon
										v-if="
											userEditableFlag &&
											(answer.status_id == 'draft' || answer.status_id == 'refused')
										"
										class="float-right"
										@click="openConfirm()"
									>
										mdi-send
									</v-icon>
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">回答日</th>
								<td width="70%" class="no-wrap">
									{{ answer.answer_date ? common.tranceMoment(answer.answer_date) : "" }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">依頼部門</th>
								<td width="70%" class="no-wrap">{{ requirement.from_department.name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">依頼者</th>
								<td width="70%" class="no-wrap">
									{{ requirement.user.last_name + " " + requirement.user.first_name }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">回答部門</th>
								<td width="70%" class="no-wrap">{{ requirement.to_department.name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">担当者</th>
								<td width="70%" class="no-wrap" v-if="from_requirement_user">
									{{ requirement.responder != null ? requirement.responder.full_name : "未定" }}
								</td>
								<td v-else width="70%" class="no-wrap">
									{{
										requirement.responder != null
											? requirement.responder.last_name + " " + requirement.responder.first_name
											: "未定"
									}}
								</td>
							</tr>
							<tr v-if="answerTemplate.need_check_flag">
								<th width="30%" class="font-weight-bold">確認者</th>
								<td width="70%" class="no-wrap" v-if="confirmations">
									<p
										class="no-wrap"
										v-for="confirmation in confirmations"
										:key="'confirmation-' + confirmation.id"
									>
										{{ confirmation.user.last_name + " " + confirmation.user.first_name }}
										<span class="fs0875">{{ confirmation.created_at | toMoment }}</span>
									</p>
								</td>
								<td width="70%" class="no-wrap" v-else></td>
							</tr>
							<tr v-if="answerTemplate.need_approval_flag">
								<th width="30%" class="font-weight-bold">承認者</th>
								<td width="70%" class="no-wrap" v-if="approvals">
									<p class="no-wrap" v-for="approval in approvals" :key="'approval-' + approval.id">
										{{ approval.user.last_name + " " + approval.user.first_name }}
										<span class="fs0875">{{ approval.created_at | toMoment }}</span>
									</p>
								</td>
								<td width="70%" class="no-wrap" v-else></td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">伝達事項</th>
								<td width="70%" class="no-wrap">
									<div
										class="pre-wrap"
										v-text="common.checkAnswerFix(answer, answer.answer_fixes, 'message')"
									></div>
									<v-icon
										v-if="userEditableFlag"
										class="float-right"
										@click="openAnswerEditDialog('伝達事項', 'text', 'message')"
										>mdi-pencil-box</v-icon
									>
								</td>
							</tr>
							<tr v-for="value in answerValues" :key="value.id">
								<th width="30%" class="font-weight-bold">
									{{ value.answer_column.name }}
									<v-icon
										class="float-right"
										v-if="checkValueFixHistory(value, value.answer_column.data_type)"
										>mdi-clock-edit-outline</v-icon
									>
								</th>
								<td width="70%" class="no-wrap" v-if="value.answer_column.data_type == 'file'">
									<v-btn
										color="transparent"
										class="no-shadow no-border pa-1"
										@click="openFilesDialog(value)"
									>
										<v-icon>mdi-folder-outline</v-icon>
										{{
											checkFileExist(value.attached_files) ? "内容を確認する" : "アップロードする"
										}}
									</v-btn>
									<p
										class="no-wrap"
										style="font-size: 0.875rem"
										v-if="!checkFileExist(value.attached_files)"
									>
										添付ファイルはありません
									</p>
								</td>
								<td width="70%" class="no-wrap" v-else-if="value.answer_column.data_type != 'text'">
									{{ showValue(value) }}
									<v-icon
										v-if="userEditableFlag"
										class="float-right"
										@click="openValueEditDialog(value)"
										>mdi-pencil-box</v-icon
									>
								</td>
								<td width="70%" class="no-wrap" v-else-if="value.answer_column.data_type == 'text'">
									<div class="pre-wrap">{{ showValue(value) }}</div>
									<v-icon
										v-if="userEditableFlag"
										class="float-right"
										@click="openValueEditDialog(value)"
										>mdi-pencil-box</v-icon
									>
								</td>
							</tr>
						</tbody>
					</table>
				</v-sheet>
			</v-sheet>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="4">
						<v-row no-gutters justify="start">
							<v-btn color="grey darken-1" text @click="openHistory(answer.id)"> 修正履歴 </v-btn>
						</v-row>
					</v-col>
					<v-col cols="4" />
					<v-col cols="4" />
				</v-row>
			</v-card-actions>
		</v-card>
		<FilesDialog ref="files" @reloadAnswer="reloadAnswer" />
		<AnswerSmallEditDialog ref="edit" @updateAnswer="updateAnswer" />
		<AnswerValueSmallEditDialog ref="editValue" @reloadAnswer="reloadAnswer" />
		<AnswerFixHistoryDialog ref="fixHistory" />
		<ChangeStatusFromDraft ref="changeFromDraft" @reloadShow="reloadShow" />
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import moment from "moment"
import FilesDialog from "./AnswerValueFilesDialog.vue"
import AnswerSmallEditDialog from "./AnswerSmallEditDialog.vue"
import AnswerFixHistoryDialog from "./AnswerFixHistoryDialog.vue"
import AnswerValueSmallEditDialog from "./AnswerValueSmallEditDialog.vue"
import ChangeStatusFromDraft from "./ChangeStatusFromDraft.vue"

export default {
	components: {
		FilesDialog,
		AnswerSmallEditDialog,
		AnswerFixHistoryDialog,
		AnswerValueSmallEditDialog,
		ChangeStatusFromDraft,
	},
	filters: {
		toMoment(date) {
			return moment(date).format("YYYY/MM/DD")
		},
	},
	props: {
		from_requirement_user: Boolean,
	},
	data() {
		return {
			open: false,
			common: common,
			answerStatusIdJpHash: {},
			requirement: {
				requirement_type: { name: "" },
				from_department: { name: "" },
				to_department: { name: "" },
				user: { last_name: "", first_name: "" },
				responder: { last_name: "", first_name: "" },
			},
			answer: {
				answer_fixes: [],
			},
			answerTemplate: {
				name: "",
				need_check_flag: false,
				need_approval_flag: false,
				requirement_type: { name: "" },
			},
			answerValues: [],
			userEditableFlag: false,
			confirmations: [],
			user: {},
			approvals: [],
		}
	},
	methods: {
		reloadList() {},
		openAnswerEditDialog(label, dataType, keyword) {
			let dataSet = {
				answer: this.answer,
				label: label,
				dataType: dataType,
				dataKey: keyword,
				user: this.user,
			}
			this.$refs.edit.setEditData(dataSet)
		},
		toJapanese(key) {
			return this.answerStatusIdJpHash[key]
		},
		checkFileExist(attachedFiles) {
			console.log(attachedFiles)
			if (!attachedFiles) {
				return false
			} else {
				let result = 0
				attachedFiles.forEach((file) => {
					if (!file.destroy_flag) {
						result += 1
					}
				})
				if (result > 0) {
					return true
				} else {
					return false
				}
			}
		},
		reloadAnswer() {
			this.openDialog(this.answer.id, this.showIndex)
		},
		openHistory(id) {
			this.$refs.fixHistory.openDialog(id)
		},
		updateAnswer(data) {
			this.answer = data
			this.$emit("reloadIndex")
		},
		editDialog(dataSet) {
			this.$refs.edit.setEditData(dataSet)
		},
		openCreateAnswer() {
			this.$router.push({ name: "answer_new", params: { id: this.requirement.id } })
		},
		reloadShow(requirement, statusName) {
			this.requirement = requirement
			this.statusName = statusName
			this.$emit("reloadIndex")
		},
		openConfirm() {
			this.$refs.changeFromDraft.openDialog(this.answer.id)
		},
		openFilesDialog(value) {
			this.$refs.files.openDialog(value.id)
		},
		diffDate(deadline) {
			let today = moment(new Date())
			let gap = moment(deadline).diff(today, "days")
			if (gap <= 5) {
				return true
			} else {
				return false
			}
		},
		resetLog() {
			this.fixedLogs = []
		},
		returnJp(word) {
			return this.requirePartJP[word]
		},
		sortCreatedAt(objectArry) {
			let sorted = objectArry.sort(function (a, b) {
				return a.created_at < b.created_at ? -1 : 1
			})
			return sorted
		},
		updateValues(values) {
			this.values = values
		},
		updateAdapt() {
			if (this.requirement.requirement_fixes && this.requirement.requirement_fixes.length > 0) {
				// 修正データの並び替え
				let sorted = this.sortCreatedAt(this.requirement.requirement_fixes)
				// 並び替えたものについて処理
				sorted.forEach((fix) => {
					let keys = ["message", "deadline", "matter_id", "subtitle"]
					// 値がnullで無い項目はrequirementの内容を更新する
					keys.forEach((key) => {
						if (fix[key] != null) {
							this.fixedPart.push(key)
							this.requirement[key] = fix[key]
							// matterの場合はサーバーに問い合わせして取得
							if (key == "matter_id" && fix["matter_id"] != null) {
								this.getOverwriteMatter()
							}
							// 更新した内容をresetLogに記載
							let hash = {
								changeDate: moment(fix.created_at).format("YYYY年MM月DD日"),
								changePartKey: key,
								changePart: this.returnJp(key),
								changeValue: fix[key],
								fixId: fix.id,
								reason: fix.reason,
							}
							this.fixedLogs.push(hash)
						}
					})
				})
			}
		},
		checkValueFixHistory(value, dataType) {
			if (value.answer_value_fixes) {
				let num = 0
				value.answer_value_fixes.forEach((fix) => {
					if (fix["value_" + dataType]) {
						num += 1
					}
				})
				if (num > 0) {
					return true
				} else {
					return false
				}
			} else {
				return false
			}
		},
		getOverwriteMatter() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/matters/" + this.requirement.matter_id + ".json", {
					headers,
				})
				.then((response) => {
					this.overwriteMatter = response.data.matter
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		openDialog(id) {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/answers/" + id + ".json", {
					headers,
				})
				.then((response) => {
					this.open = true
					this.answerStatusIdJpHash = response.data.status_ids_i18n
					this.requirement = response.data.requirement
					this.answer = response.data.answer
					this.answerTemplate = response.data.answer.answer_template
					this.answerValues = response.data.answer.answer_values
					this.userEditableFlag = response.data.user_editable_flag
					this.approvals = response.data.answer.approvals
					this.confirmations = response.data.answer.confirmations
					console.log(response.data)
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		openValueEditDialog(value) {
			let dataSet = {
				value: value,
				answer: this.answer,
				column: value.answer_column,
				user: this.user,
			}
			this.$refs.editValue.setEditData(dataSet)
		},
		openRequirementEditDialog(label, dataType, keyword) {
			let dataSet = {
				requirement: this.requirement,
				selectedMatter: this.requirement.matter,
				label: label,
				dataType: dataType,
				dataKey: keyword,
				showIndex: this.showIndex,
				user: this.user,
			}
			this.$refs.edit.setEditData(dataSet)
		},
		valueValue(value) {
			return common.returnValueValue(value)
		},
		showValue(value) {
			if (value.answer_value_fixes && value.answer_value_fixes.length > 0) {
				let resultValue = ""
				let sortedFixes = common.sortCreatedAt(value.answer_value_fixes)
				sortedFixes.forEach((fix) => {
					resultValue = fix["value_" + value.answer_column.data_type]
				})
				return common.returnValue(resultValue, value.answer_column.data_type)
			} else {
				return this.valueValue(value)
			}
		},
	},
	computed: {},
	watch: {
		requirement: {
			handler() {
				this.fixedPart = []
				this.resetLog()
				this.updateAdapt()
			},
		},
	},
}
</script>

<style>
.no-border {
	border: none;
}
.no-shadow {
	box-shadow: none;
}
.fs0875 {
	font-size: 0.875rem;
}
</style>
